import { createStyles, Popover } from '@material-ui/core';
import { addMinutes, format } from 'date-fns';
import * as React from 'react';
import { compose, withHandlers, withState } from 'recompose';
import { withBaseProps } from '../../Utils';
import { DateRangePicker } from '../DateRangePicker';
import { TextInput } from '../TextInput';
const styles = () => createStyles({
    suffixRoot: {
        cursor: 'pointer',
        '&:hover': {
            opacity: 1,
        },
    },
    closeIcon: {
        color: 'hsl(0,0%,80%)!important',
        '&:hover': {
            color: 'hsl(0,0%,60%)!important',
        },
    },
});
const DateRangePickerInput = (props) => {
    const { open, disableSelectMonthDropdown, setOpen, selectDateRangeHandler, focusHandler, dateRangeSelected, clearHandler, dateFormat, locale, label, t, placeholder, initialDateRange, disabled, className, classes, onChange, weekStartsOn = 1, setDateRangeSelected, removable = true, disabledFutureDates, maxRangeInMonths, testId = 'DateRangePickerInput', ...others } = props;
    const { input, meta } = others;
    const ref = React.useRef(null);
    React.useEffect(() => {
        if (input && input.value) {
            setDateRangeSelected(input.value);
        }
    }, [input && input.value]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: ref },
            React.createElement(TextInput, { className: className, classes: { suffix: classes.suffixRoot }, disabled: open || disabled, input: input, label: label, meta: meta, onFocus: focusHandler, placeholder: placeholder || dateFormat, "data-testid": testId, value: (dateRangeSelected && dateRangeSelected.labelKey && t(`dates:${dateRangeSelected.labelKey}`)) ||
                    (dateRangeSelected &&
                        dateRangeSelected.startDate &&
                        `${format(dateRangeSelected.startDate, dateFormat)} - ${format(dateRangeSelected.endDate, dateFormat)}`) ||
                    '', postLabel: dateRangeSelected &&
                    removable && (React.createElement("svg", { height: "20", width: "20", viewBox: "0 0 20 20", "aria-hidden": "true", focusable: "false", className: classes.closeIcon, onClick: clearHandler },
                    React.createElement("path", { d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z" }))) })),
        React.createElement(Popover, { open: open, onClose: () => {
                setOpen(false);
            }, anchorEl: ref.current, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
            }, marginThreshold: 0, disableRestoreFocus: true },
            React.createElement(DateRangePicker, Object.assign({ dateFormat: dateFormat, onChange: selectDateRangeHandler, initialDateRange: initialDateRange || dateRangeSelected, open: open, disableSelectMonthDropdown: disableSelectMonthDropdown, locale: locale, weekStartsOn: weekStartsOn, maxDate: disabledFutureDates && addMinutes(new Date(), 1), maxRangeInMonths: maxRangeInMonths }, others)))));
};
const ComposedDateRangePickerInput = compose(withBaseProps({ styles }), withState('open', 'setOpen', false), withState('dateRangeSelected', 'setDateRangeSelected', ({ initialDate, input }) => {
    return initialDate || (input && input.value);
}), withHandlers({
    selectDateRangeHandler: ({ input, onDateRangeChange, setDateRangeSelected, setOpen }) => (dateRange) => {
        if (onDateRangeChange) {
            onDateRangeChange(dateRange);
        }
        if (input && input.onChange) {
            input.onChange(dateRange);
        }
        setDateRangeSelected(dateRange);
        setOpen(false);
    },
    focusHandler: ({ setOpen }) => () => setOpen(true),
    clearHandler: ({ setDateRangeSelected, input, onDateRangeChange }) => () => {
        if (onDateRangeChange) {
            onDateRangeChange('');
        }
        if (input && input.onChange) {
            input.onChange('');
        }
        setDateRangeSelected('');
    },
}))(DateRangePickerInput);
ComposedDateRangePickerInput.displayName = 'DateRangePickerInput';
export default ComposedDateRangePickerInput;
//# sourceMappingURL=DateRangePickerInput.js.map